// AUTO-GENERATED preview fixture — do not hand-edit. See apps/mobile/preview/README.md.
// Post-elim placement where the attacker (slot 1) ALSO turned in a card set: budget 13 = +5 elimination bonus + 8 card bonus. Subtitle shows only the +5 elimination portion.
import type { GameResponse } from '@warcarp/api-types'

export const game = {
  "id": "preview-elim-plus-card",
  "adminId": "uu-1",
  "name": "Preview \u2014 Elimination + card bonus",
  "status": "ACTIVE",
  "mode": "PASS_AND_PLAY",
  "minPlayers": 5,
  "maxPlayers": 5,
  "currentPlayerIndex": 0,
  "currentTurn": 6,
  "mapId": "minnesota",
  "isPublic": false,
  "inviteCode": null,
  "setupConfig": {
    "startingTroops": 7,
    "cardBonusSchedule": "cycle",
    "maxAttacksPerTurn": null,
    "maxFortifiesPerTurn": 5,
    "eliminatePlayerBonus": 5,
    "autoAssignTerritories": true
  },
  "viewerInvitationStatus": null,
  "startedAt": "2026-06-08T18:53:02.354Z",
  "completedAt": null,
  "createdAt": "2026-06-08T18:52:48.411Z",
  "players": [
    {
      "id": "pp-1",
      "userId": "uu-1",
      "slot": 1,
      "playerIndex": 0,
      "displayName": "Sarge",
      "isBot": false,
      "isReady": true,
      "color": null,
      "score": null,
      "rank": null,
      "joinedAt": "2026-06-08T18:52:48.411Z",
      "botPersonality": null,
      "user": {
        "id": "uu-1",
        "displayName": "Sarge"
      }
    },
    {
      "id": "pp-2",
      "userId": "uu-2",
      "slot": 2,
      "playerIndex": 1,
      "displayName": "Pike",
      "isBot": true,
      "isReady": true,
      "color": null,
      "score": null,
      "rank": null,
      "joinedAt": "2026-06-08T18:52:48.411Z",
      "botPersonality": null,
      "user": {
        "id": "uu-2",
        "displayName": "Pike"
      }
    },
    {
      "id": "pp-3",
      "userId": "uu-3",
      "slot": 3,
      "playerIndex": 2,
      "displayName": "Ursula",
      "isBot": true,
      "isReady": true,
      "color": null,
      "score": null,
      "rank": null,
      "joinedAt": "2026-06-08T18:52:48.411Z",
      "botPersonality": null,
      "user": {
        "id": "uu-3",
        "displayName": "Ursula"
      }
    },
    {
      "id": "pp-4",
      "userId": "uu-4",
      "slot": 4,
      "playerIndex": 3,
      "displayName": "Ace",
      "isBot": true,
      "isReady": true,
      "color": null,
      "score": null,
      "rank": null,
      "joinedAt": "2026-06-08T18:52:48.411Z",
      "botPersonality": null,
      "user": {
        "id": "uu-4",
        "displayName": "Ace"
      }
    },
    {
      "id": "pp-5",
      "userId": "uu-5",
      "slot": 5,
      "playerIndex": 4,
      "displayName": "Yeoman",
      "isBot": true,
      "isReady": true,
      "color": null,
      "score": null,
      "rank": 5,
      "joinedAt": "2026-06-08T18:52:48.411Z",
      "botPersonality": null,
      "user": {
        "id": "uu-5",
        "displayName": "Yeoman"
      }
    }
  ],
  "invitations": [],
  "state": {
    "config": {
      "maxTurns": 500,
      "startingTroops": 7,
      "cardBonusSchedule": "cycle",
      "maxAttacksPerTurn": null,
      "maxFortifiesPerTurn": 5,
      "eliminatePlayerBonus": 5,
      "autoAssignTerritories": true
    },
    "rngSeed": "843472878",
    "cards": {
      "1": [
        {
          "id": "c-a",
          "type": "cavalry",
          "territoryId": "cook"
        },
        {
          "id": "c-b",
          "type": "artillery",
          "territoryId": "lake"
        }
      ],
      "2": [],
      "3": [],
      "4": [],
      "5": []
    },
    "deck": [
      {
        "id": "card-37",
        "type": "artillery",
        "territoryId": "de"
      },
      {
        "id": "card-22",
        "type": "cavalry",
        "territoryId": "oh"
      },
      {
        "id": "card-5",
        "type": "infantry",
        "territoryId": "wy"
      },
      {
        "id": "card-15",
        "type": "cavalry",
        "territoryId": "ia"
      },
      {
        "id": "card-11",
        "type": "infantry",
        "territoryId": "sd"
      },
      {
        "id": "card-25",
        "type": "cavalry",
        "territoryId": "wv"
      },
      {
        "id": "card-27",
        "type": "cavalry",
        "territoryId": "nc"
      },
      {
        "id": "card-17",
        "type": "cavalry",
        "territoryId": "co"
      },
      {
        "id": "card-23",
        "type": "cavalry",
        "territoryId": "ky"
      },
      {
        "id": "card-39",
        "type": "artillery",
        "territoryId": "ok"
      },
      {
        "id": "card-2",
        "type": "infantry",
        "territoryId": "id"
      },
      {
        "id": "card-13",
        "type": "infantry",
        "territoryId": "ne"
      },
      {
        "id": "card-4",
        "type": "infantry",
        "territoryId": "mt"
      },
      {
        "id": "card-8",
        "type": "infantry",
        "territoryId": "az"
      },
      {
        "id": "card-33",
        "type": "artillery",
        "territoryId": "nh"
      },
      {
        "id": "card-20",
        "type": "cavalry",
        "territoryId": "in"
      },
      {
        "id": "card-21",
        "type": "cavalry",
        "territoryId": "mi"
      },
      {
        "id": "card-29",
        "type": "artillery",
        "territoryId": "pa"
      },
      {
        "id": "card-3",
        "type": "infantry",
        "territoryId": "ca"
      },
      {
        "id": "card-19",
        "type": "cavalry",
        "territoryId": "il"
      },
      {
        "id": "card-6",
        "type": "infantry",
        "territoryId": "nv"
      },
      {
        "id": "card-42",
        "type": "wild"
      },
      {
        "id": "card-14",
        "type": "cavalry",
        "territoryId": "ks"
      },
      {
        "id": "card-40",
        "type": "artillery",
        "territoryId": "ar"
      },
      {
        "id": "card-41",
        "type": "artillery",
        "territoryId": "ms"
      },
      {
        "id": "card-36",
        "type": "artillery",
        "territoryId": "md"
      },
      {
        "id": "card-28",
        "type": "artillery",
        "territoryId": "ny"
      },
      {
        "id": "card-35",
        "type": "artillery",
        "territoryId": "me"
      },
      {
        "id": "card-10",
        "type": "infantry",
        "territoryId": "nd"
      },
      {
        "id": "card-7",
        "type": "infantry",
        "territoryId": "ut"
      },
      {
        "id": "card-24",
        "type": "cavalry",
        "territoryId": "tn"
      },
      {
        "id": "card-1",
        "type": "infantry",
        "territoryId": "or"
      },
      {
        "id": "card-43",
        "type": "wild"
      },
      {
        "id": "card-18",
        "type": "cavalry",
        "territoryId": "wi"
      },
      {
        "id": "card-16",
        "type": "cavalry",
        "territoryId": "mo"
      },
      {
        "id": "card-34",
        "type": "artillery",
        "territoryId": "vt"
      },
      {
        "id": "card-9",
        "type": "infantry",
        "territoryId": "nm"
      },
      {
        "id": "card-12",
        "type": "infantry",
        "territoryId": "mn"
      },
      {
        "id": "card-38",
        "type": "artillery",
        "territoryId": "tx"
      },
      {
        "id": "card-31",
        "type": "artillery",
        "territoryId": "ct"
      },
      {
        "id": "card-0",
        "type": "infantry",
        "territoryId": "wa"
      }
    ],
    "discard": [],
    "bonusArmies": {
      "1": 13
    },
    "armiesToPlace": 0,
    "cardTurnIns": 1,
    "mustTurnInCards": false,
    "initialTerritories": [
      {
        "id": "wa",
        "armies": 7,
        "ownerId": "1"
      },
      {
        "id": "or",
        "armies": 7,
        "ownerId": "1"
      },
      {
        "id": "id",
        "armies": 7,
        "ownerId": "2"
      },
      {
        "id": "ca",
        "armies": 7,
        "ownerId": "2"
      },
      {
        "id": "mt",
        "armies": 7,
        "ownerId": "2"
      },
      {
        "id": "wy",
        "armies": 7,
        "ownerId": "1"
      },
      {
        "id": "nv",
        "armies": 7,
        "ownerId": "1"
      },
      {
        "id": "ut",
        "armies": 7,
        "ownerId": "2"
      },
      {
        "id": "az",
        "armies": 7,
        "ownerId": "1"
      },
      {
        "id": "nm",
        "armies": 7,
        "ownerId": ""
      },
      {
        "id": "nd",
        "armies": 7,
        "ownerId": "2"
      },
      {
        "id": "sd",
        "armies": 7,
        "ownerId": "2"
      },
      {
        "id": "mn",
        "armies": 7,
        "ownerId": "1"
      },
      {
        "id": "ne",
        "armies": 7,
        "ownerId": "1"
      },
      {
        "id": "ks",
        "armies": 7,
        "ownerId": "2"
      },
      {
        "id": "ia",
        "armies": 7,
        "ownerId": "1"
      },
      {
        "id": "mo",
        "armies": 7,
        "ownerId": "2"
      },
      {
        "id": "co",
        "armies": 7,
        "ownerId": "2"
      },
      {
        "id": "wi",
        "armies": 7,
        "ownerId": "1"
      },
      {
        "id": "il",
        "armies": 7,
        "ownerId": "2"
      },
      {
        "id": "in",
        "armies": 7,
        "ownerId": "1"
      },
      {
        "id": "mi",
        "armies": 7,
        "ownerId": "1"
      },
      {
        "id": "oh",
        "armies": 7,
        "ownerId": "2"
      },
      {
        "id": "ky",
        "armies": 7,
        "ownerId": "2"
      },
      {
        "id": "tn",
        "armies": 7,
        "ownerId": "1"
      },
      {
        "id": "wv",
        "armies": 7,
        "ownerId": "2"
      },
      {
        "id": "va",
        "armies": 7,
        "ownerId": "1"
      },
      {
        "id": "nc",
        "armies": 7,
        "ownerId": "1"
      },
      {
        "id": "ny",
        "armies": 7,
        "ownerId": "2"
      },
      {
        "id": "pa",
        "armies": 7,
        "ownerId": "2"
      },
      {
        "id": "nj",
        "armies": 7,
        "ownerId": "2"
      },
      {
        "id": "ct",
        "armies": 7,
        "ownerId": "2"
      },
      {
        "id": "ma",
        "armies": 7,
        "ownerId": "1"
      },
      {
        "id": "nh",
        "armies": 7,
        "ownerId": "2"
      },
      {
        "id": "vt",
        "armies": 7,
        "ownerId": "1"
      },
      {
        "id": "me",
        "armies": 7,
        "ownerId": "1"
      },
      {
        "id": "md",
        "armies": 7,
        "ownerId": "1"
      },
      {
        "id": "de",
        "armies": 7,
        "ownerId": "1"
      },
      {
        "id": "tx",
        "armies": 7,
        "ownerId": "1"
      },
      {
        "id": "ok",
        "armies": 7,
        "ownerId": "2"
      },
      {
        "id": "ar",
        "armies": 7,
        "ownerId": "2"
      },
      {
        "id": "ms",
        "armies": 7,
        "ownerId": "1"
      },
      {
        "id": "al",
        "armies": 7,
        "ownerId": "1"
      },
      {
        "id": "ga",
        "armies": 7,
        "ownerId": "2"
      },
      {
        "id": "sc",
        "armies": 7,
        "ownerId": "2"
      },
      {
        "id": "la",
        "armies": 7,
        "ownerId": "1"
      },
      {
        "id": "fl",
        "armies": 7,
        "ownerId": "2"
      }
    ],
    "eventCount": 40,
    "events": [],
    "mapId": "minnesota",
    "players": [
      "1",
      "2",
      "3",
      "4",
      "5"
    ],
    "eliminated": [
      "5"
    ],
    "phase": "post-elim-placement",
    "turnIndex": 0,
    "roundsPlayed": 6,
    "attacksThisTurn": 2,
    "fortifiesThisTurn": 0,
    "conqueredThisTurn": true,
    "lastConquest": null,
    "territories": [
      {
        "id": "cook",
        "ownerId": "1",
        "armies": 1
      },
      {
        "id": "lake",
        "ownerId": "1",
        "armies": 2
      },
      {
        "id": "saint-louis",
        "ownerId": "1",
        "armies": 3
      },
      {
        "id": "carlton",
        "ownerId": "1",
        "armies": 4
      },
      {
        "id": "itasca",
        "ownerId": "1",
        "armies": 5
      },
      {
        "id": "koochiching",
        "ownerId": "1",
        "armies": 6
      },
      {
        "id": "lake-of-the-woods",
        "ownerId": "1",
        "armies": 1
      },
      {
        "id": "kittson",
        "ownerId": "1",
        "armies": 2
      },
      {
        "id": "roseau",
        "ownerId": "1",
        "armies": 3
      },
      {
        "id": "marshall",
        "ownerId": "1",
        "armies": 4
      },
      {
        "id": "pennington",
        "ownerId": "1",
        "armies": 5
      },
      {
        "id": "red-lake",
        "ownerId": "1",
        "armies": 6
      },
      {
        "id": "polk",
        "ownerId": "1",
        "armies": 1
      },
      {
        "id": "norman",
        "ownerId": "1",
        "armies": 2
      },
      {
        "id": "mahnomen",
        "ownerId": "1",
        "armies": 3
      },
      {
        "id": "clay",
        "ownerId": "1",
        "armies": 4
      },
      {
        "id": "becker",
        "ownerId": "1",
        "armies": 5
      },
      {
        "id": "beltrami",
        "ownerId": "1",
        "armies": 6
      },
      {
        "id": "clearwater",
        "ownerId": "1",
        "armies": 1
      },
      {
        "id": "hubbard",
        "ownerId": "1",
        "armies": 2
      },
      {
        "id": "cass",
        "ownerId": "1",
        "armies": 3
      },
      {
        "id": "crow-wing",
        "ownerId": "1",
        "armies": 4
      },
      {
        "id": "aitkin",
        "ownerId": "1",
        "armies": 5
      },
      {
        "id": "wadena",
        "ownerId": "1",
        "armies": 6
      },
      {
        "id": "otter-tail",
        "ownerId": "1",
        "armies": 1
      },
      {
        "id": "mille-lacs",
        "ownerId": "1",
        "armies": 2
      },
      {
        "id": "kanabec",
        "ownerId": "1",
        "armies": 3
      },
      {
        "id": "pine",
        "ownerId": "1",
        "armies": 4
      },
      {
        "id": "morrison",
        "ownerId": "1",
        "armies": 5
      },
      {
        "id": "todd",
        "ownerId": "1",
        "armies": 6
      },
      {
        "id": "stearns",
        "ownerId": "1",
        "armies": 1
      },
      {
        "id": "benton",
        "ownerId": "1",
        "armies": 2
      },
      {
        "id": "sherburne",
        "ownerId": "1",
        "armies": 3
      },
      {
        "id": "isanti",
        "ownerId": "1",
        "armies": 4
      },
      {
        "id": "chisago",
        "ownerId": "1",
        "armies": 5
      },
      {
        "id": "wilkin",
        "ownerId": "1",
        "armies": 6
      },
      {
        "id": "grant",
        "ownerId": "1",
        "armies": 1
      },
      {
        "id": "traverse",
        "ownerId": "2",
        "armies": 2
      },
      {
        "id": "big-stone",
        "ownerId": "3",
        "armies": 3
      },
      {
        "id": "stevens",
        "ownerId": "4",
        "armies": 4
      },
      {
        "id": "pope",
        "ownerId": "1",
        "armies": 5
      },
      {
        "id": "douglas",
        "ownerId": "2",
        "armies": 6
      },
      {
        "id": "swift",
        "ownerId": "3",
        "armies": 1
      },
      {
        "id": "chippewa",
        "ownerId": "4",
        "armies": 2
      },
      {
        "id": "lac-qui-parle",
        "ownerId": "1",
        "armies": 3
      },
      {
        "id": "yellow-medicine",
        "ownerId": "2",
        "armies": 4
      },
      {
        "id": "kandiyohi",
        "ownerId": "3",
        "armies": 5
      },
      {
        "id": "lincoln",
        "ownerId": "4",
        "armies": 6
      },
      {
        "id": "lyon",
        "ownerId": "1",
        "armies": 1
      },
      {
        "id": "redwood",
        "ownerId": "2",
        "armies": 2
      },
      {
        "id": "renville",
        "ownerId": "3",
        "armies": 3
      },
      {
        "id": "pipestone",
        "ownerId": "4",
        "armies": 4
      },
      {
        "id": "murray",
        "ownerId": "1",
        "armies": 5
      },
      {
        "id": "cottonwood",
        "ownerId": "2",
        "armies": 6
      },
      {
        "id": "brown",
        "ownerId": "3",
        "armies": 1
      },
      {
        "id": "rock",
        "ownerId": "4",
        "armies": 2
      },
      {
        "id": "nobles",
        "ownerId": "1",
        "armies": 3
      },
      {
        "id": "jackson",
        "ownerId": "2",
        "armies": 4
      },
      {
        "id": "martin",
        "ownerId": "3",
        "armies": 5
      },
      {
        "id": "watonwan",
        "ownerId": "4",
        "armies": 6
      },
      {
        "id": "anoka",
        "ownerId": "1",
        "armies": 1
      },
      {
        "id": "hennepin",
        "ownerId": "2",
        "armies": 2
      },
      {
        "id": "ramsey",
        "ownerId": "3",
        "armies": 3
      },
      {
        "id": "washington",
        "ownerId": "4",
        "armies": 4
      },
      {
        "id": "carver",
        "ownerId": "1",
        "armies": 5
      },
      {
        "id": "scott",
        "ownerId": "2",
        "armies": 6
      },
      {
        "id": "dakota",
        "ownerId": "3",
        "armies": 1
      },
      {
        "id": "wright",
        "ownerId": "4",
        "armies": 2
      },
      {
        "id": "meeker",
        "ownerId": "1",
        "armies": 3
      },
      {
        "id": "mcleod",
        "ownerId": "2",
        "armies": 4
      },
      {
        "id": "sibley",
        "ownerId": "3",
        "armies": 5
      },
      {
        "id": "le-sueur",
        "ownerId": "4",
        "armies": 6
      },
      {
        "id": "nicollet",
        "ownerId": "1",
        "armies": 1
      },
      {
        "id": "blue-earth",
        "ownerId": "2",
        "armies": 2
      },
      {
        "id": "waseca",
        "ownerId": "3",
        "armies": 3
      },
      {
        "id": "steele",
        "ownerId": "4",
        "armies": 4
      },
      {
        "id": "rice",
        "ownerId": "1",
        "armies": 5
      },
      {
        "id": "goodhue",
        "ownerId": "2",
        "armies": 6
      },
      {
        "id": "wabasha",
        "ownerId": "3",
        "armies": 1
      },
      {
        "id": "olmsted",
        "ownerId": "4",
        "armies": 2
      },
      {
        "id": "dodge",
        "ownerId": "1",
        "armies": 3
      },
      {
        "id": "faribault",
        "ownerId": "2",
        "armies": 4
      },
      {
        "id": "freeborn",
        "ownerId": "3",
        "armies": 5
      },
      {
        "id": "mower",
        "ownerId": "4",
        "armies": 6
      },
      {
        "id": "fillmore",
        "ownerId": "1",
        "armies": 1
      },
      {
        "id": "winona",
        "ownerId": "2",
        "armies": 2
      },
      {
        "id": "houston",
        "ownerId": "3",
        "armies": 3
      }
    ]
  }
} as unknown as GameResponse
